import { render, staticRenderFns } from "./FullscreenSidebar.vue?vue&type=template&id=6d5447d8"
import script from "./FullscreenSidebar.vue?vue&type=script&lang=js"
export * from "./FullscreenSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports